import { BaseItemStore } from "../core/BaseStore";
import type ActivityModel from "./ActivityModel";

export default class ActivitiesStore extends BaseItemStore<ActivityModel> {}
